(() => {
  let latestCart = null;
  let renderQueued = false;

  const cartEndpointPattern = /\/cart(?:\/(?:change|update))?\.js(?:\?|$)/;

  const formatMoney = cents => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, document.body.dataset.moneyFormat);
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: document.body.dataset.shopCurrency || 'USD'
    }).format(cents / 100);
  };

  const renderOptions = (title, item) => {
    const existing = title.querySelector('[data-wrc-cart-options]');
    const options = Array.isArray(item.options_with_values)
      ? item.options_with_values.filter(option => option.name !== 'Title' && option.value !== 'Default Title')
      : [];

    if (!options.length) {
      if (existing) existing.remove();
      return;
    }

    const list = existing || document.createElement('dl');
    list.className = 'wrc-mini-cart__options';
    list.dataset.wrcCartOptions = '';
    list.replaceChildren();

    options.forEach(option => {
      const row = document.createElement('div');
      const name = document.createElement('dt');
      const value = document.createElement('dd');

      row.className = 'wrc-mini-cart__option';
      name.textContent = `${option.name}:`;
      value.textContent = option.value;
      row.append(name, value);
      list.append(row);
    });

    if (!existing) {
      const productLink = title.querySelector('a');
      productLink.insertAdjacentElement('afterend', list);
    }
  };

  const renderLineItems = (form, cart) => {
    form.querySelectorAll('[data-cart-item]').forEach((line, index) => {
      const item = cart.items[index];
      if (!item) return;

      const title = line.querySelector('.mini-cart__item-title');
      const productLink = title && title.querySelector('a');
      if (productLink && item.product_title) {
        productLink.textContent = item.product_title;
        productLink.dataset.wrcCartProductTitle = '';
      }
      if (title) renderOptions(title, item);

      const image = line.querySelector('.cart_image img');
      if (image && item.product_title) image.alt = item.product_title;

      const remove = line.querySelector('[data-remove-item]');
      if (remove && !remove.querySelector('.remove-text')) {
        const removeText = document.createElement('span');
        removeText.className = 'remove-text';
        removeText.textContent = 'Remove';
        remove.prepend(removeText);
        const removeIcon = remove.querySelector('.remove-icon');
        if (removeIcon) removeIcon.setAttribute('aria-hidden', 'true');
      }
    });
  };

  const renderCart = cart => {
    if (!cart || !Array.isArray(cart.items)) return;

    document.querySelectorAll('[data-wrc-cart-count]').forEach(count => {
      count.textContent = cart.item_count;
    });

    document.querySelectorAll('[data-wrc-checkout-total]').forEach(total => {
      total.textContent = formatMoney(cart.total_price);
    });

    document.querySelectorAll('[data-cart-form="mini-cart"]').forEach(form => {
      renderLineItems(form, cart);
    });
  };

  const queueRender = () => {
    if (!latestCart || renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(() => {
      renderQueued = false;
      renderCart(latestCart);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', event => {
      const closeButton = event.target.closest('.wrc-mini-cart__close');
      if (!closeButton) return;

      event.preventDefault();
      document.body.classList.remove('is-active', 'blocked-scroll');
      document.querySelectorAll('.dropdown_link.active_link, .cart-container.active_link').forEach(element => {
        element.classList.remove('active_link');
      });
    });

    if (window.jQuery) {
      window.jQuery(document).on('ajaxSuccess.wrcMiniCart', (event, xhr, settings, data) => {
        if (!settings || !cartEndpointPattern.test(settings.url || '') || !data || !Array.isArray(data.items)) return;
        latestCart = data;
        queueRender();
      });
    }

    const observer = new MutationObserver(records => {
      if (!latestCart) return;
      const cartChanged = records.some(record => {
        const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        return target && target.closest('.js-cart_items, .js-cart_subtotal, .cart_count');
      });
      if (cartChanged) queueRender();
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();
